import { render, staticRenderFns } from "./MoreDetailsDialog.vue?vue&type=template&id=ddc268ee&scoped=true&"
import script from "./MoreDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./MoreDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreDetailsDialog.vue?vue&type=style&index=0&id=ddc268ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc268ee",
  null
  
)

export default component.exports